/**
 * Determines if a hex color is dark (66% or darker)
 * Uses weighted luminance calculation for better perceptual accuracy
 * @param {string} hexColor - Hex color string (with or without #)
 * @returns {boolean} True if the color is dark, false otherwise
 */
export const isDarkColor = (hexColor) => {
  if (!hexColor) return true; // Default to dark if no color provided
  
  // Remove # if present and ensure we have a valid hex color
  const hex = hexColor.replace("#", "");

  // Validate hex color format
  if (!/^[0-9A-Fa-f]{6}$/.test(hex)) {
    return true; // Default to dark for invalid colors
  }

  // Parse RGB values
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Calculate weighted luminance (accounts for human eye sensitivity)
  // Formula: 0.299*R + 0.587*G + 0.114*B
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

  // Normalize to 0-1 scale and check if darker than 50%
  const brightnessThreshold = 255 * 0.5;

  return luminance < brightnessThreshold;
};
